// Public API — única porta de entrada para pages e outros módulos.
// Nenhum arquivo interno deve ser importado diretamente de fora deste módulo.

export { OfferUnavailableScreen } from './screens/OfferUnavailableScreen/OfferUnavailableScreen';
export { OfferCountdownTopBar } from './components/OfferCountdownTopBar/OfferCountdownTopBar';
export { OfferSummaryUrgency } from './components/OfferSummaryUrgency/OfferSummaryUrgency';
export { useOfferCountdown } from './hooks/useOfferCountdown';
export { useOfferRemainingSlots } from './hooks/useOfferRemainingSlots';
export { useBoletoLock } from './hooks/useBoletoLock';
export { OFFER_BOLETO_CUTOFF_TEXTS } from './constants/texts';
export {
  BOLETO_CUTOFF_TIME_ZONE,
  computeBoletoCutoff,
  isBoletoLocked,
} from './utils/boletoCutoff';
export { useSoldOutOfferRedirect } from './hooks/useSoldOutOfferRedirect';
export { OFFER_COUNTDOWN_BAR_SLOT_ID } from './constants/slots';
export { resolveOfferProductSales } from './utils/resolveOfferProductSales';
export { resolveOfferLeadDiversion } from './utils/resolveOfferLeadDiversion';
export { logOfferUnavailable } from './utils/logOfferUnavailable';
export { divertUnavailableOfferLead } from './utils/divertUnavailableOfferLead';
export { resolveOfferLeadDiversionFresh } from './utils/resolveOfferLeadDiversionFresh';
export type { FetchOfferAvailability } from './utils/resolveOfferLeadDiversionFresh';
export {
  OFFER_REFUSAL_CODES,
  getOfferRefusalCode,
  isOfferRefusalCode,
  toOfferLogReason,
  toOfferRefusedReason,
} from './utils/offerRefusal';
export {
  OFFER_CLOSED_REASON,
  OFFER_NOT_STARTED_REASON,
  OFFER_NOT_STARTED_REFUSED_REASON,
  OFFER_REFUSED_REASON,
  OFFER_SOLD_OUT_REASON,
  OFFER_SOLD_OUT_REFUSED_REASON,
  OFFER_UNAVAILABLE_PATH,
  buildOfferUnavailableRoute,
  parseOfferUnavailableReason,
} from './utils/offerUnavailableRoute';
export type { OfferUnavailableReason } from './utils/offerUnavailableRoute';
export type {
  OfferAvailabilityStatus,
  OfferPlanAvailability,
  OfferLeadDiversionReason,
  OfferProductSales,
  OfferUnavailableLogReason,
} from './types';
